import React from 'react';
import { STAGES } from './sales-config';

const FunnelBackground = ({ width, height, stageWidth }) => {
  // Funnel Shape Logic:
  // We want to "narrow down" the start and end widening slightly.
  
  // Vertical boundary percentages (0 to 1 based on height)
  
  // Neck (Middle section) - Constant
  const neckHeight = height * 0.30; 
  const neckTop = (height - neckHeight) / 2; // ~35%
  const neckBottom = neckTop + neckHeight;   // ~65%

  // Mouth (Start and End) - Reduced spread to "narrow down" the widening
  // Previously 0.15 to 0.85 (70% spread). 
  // Let's make it 0.22 to 0.78 (56% spread).
  const mouthTop = height * 0.22; 
  const mouthBottom = height * 0.78;

  // X Coordinates
  const x0 = 0;
  const x1 = stageWidth; // End of Sales
  const x4 = stageWidth * 4; // Start of Marketing
  const x5 = width; // End of Marketing

  // Top Path Construction
  // Move to Start
  let pathTop = `M ${x0} ${mouthTop}`;
  // Curve down to neck over the first stage
  // Control points: 
  // CP1: Pulls horizontally from start.
  // CP2: Pulls horizontally towards neck.
  pathTop += ` C ${x1 * 0.5} ${mouthTop}, ${x1 * 0.5} ${neckTop}, ${x1} ${neckTop}`;
  
  // Line across middle stages (Delivery, Accounting, CX)
  pathTop += ` L ${x4} ${neckTop}`;
  
  // Curve up to mouth over last stage (Marketing)
  pathTop += ` C ${x4 + (stageWidth * 0.5)} ${neckTop}, ${x4 + (stageWidth * 0.5)} ${mouthTop}, ${x5} ${mouthTop}`;

  // Bottom Path Construction (Mirror)
  let pathBottom = `M ${x0} ${mouthBottom}`;
  pathBottom += ` C ${x1 * 0.5} ${mouthBottom}, ${x1 * 0.5} ${neckBottom}, ${x1} ${neckBottom}`;
  pathBottom += ` L ${x4} ${neckBottom}`;
  pathBottom += ` C ${x4 + (stageWidth * 0.5)} ${neckBottom}, ${x4 + (stageWidth * 0.5)} ${mouthBottom}, ${x5} ${mouthBottom}`;

  // Grid Lines
  const gridLines = [];
  
  STAGES.forEach((stage, stageIndex) => {
    const stageStartX = stageIndex * stageWidth;
    const subStageWidth = stageWidth / stage.subLabels.length;
    
    // Draw lines between sub-stages
    for (let i = 1; i < stage.subLabels.length; i++) {
      const lineX = stageStartX + (i * subStageWidth);
      gridLines.push(
        <line 
          key={`sub-${stage.id}-${i}`}
          x1={lineX} y1={0}
          x2={lineX} y2={height}
          stroke="#e2e8f0" 
          strokeWidth="1"
          strokeDasharray="4 4"
        />
      );
    }
    
    // Draw solid line between major stages
    if (stageIndex > 0) {
      gridLines.push(
        <line 
          key={`major-${stageIndex}`}
          x1={stageStartX} y1={0}
          x2={stageStartX} y2={height}
          stroke="#94a3b8" 
          strokeWidth="1"
        />
      );
    }
  });

  return (
    <div className="funnel-bg-wrapper">
      <svg width={width} height={height} className="funnel-svg">
        {gridLines}
        <path d={pathTop} fill="none" stroke="#1e293b" strokeWidth="1.5" strokeLinecap="round" />
        <path d={pathBottom} fill="none" stroke="#1e293b" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export default FunnelBackground;